<template lang="pug">
  vueCustomScrollbar.scroll-area(:settings="settings")
    table#tbTanquesLlegando.table.is-striped.is-responsive
      thead
        tr
          th #
          th Autotanque
          th Fecha Registro
          th Razón Social
          th(v-show="verPrograma") Programa
          th Empresa
          th ID nominacion
          th Peso Entrada
          th Peso Salida
          th Peso Neto / Carga
          th(v-show="verDataBascula") Magnatel
          th(v-show="verDataBascula") Presión
          th(v-show="verCartasPorte") Carta Porte
          th Sellos
      tbody
        tr(v-for="(data, index) in autotanques" :key="data.id")
          td
            a.button.is-black.is-rounded.is-small
              | {{ index + 1 }}
          td.is-size-7 {{ data.pg }}
          td.is-size-7 {{ data.fechaLlegada }}
          td.is-size-7
            span
              | {{ data.porteador }}
          td.is-size-7(v-show="verPrograma")
            a.button.is-rounded.is-small(:class="data.programa ? 'is-success' : 'is-warning'" @click="changePrograma(data)")
              | {{ data.programa ? 'SI' : 'NO'}}
          td.is-size-7
            a.button.is-rounded.is-small(:style="getbgColor(data)" @click="changeGrupo(data)")
              span(v-show="data.grupo !==''")
                | {{ data.grupo }} - {{ data.compania }}
              span.icon(v-show="data.grupo ===''")
                i.fas.fa-plus
              span(v-show="data.grupo ===''") &nbspGrupo
          td.is-size-7 {{ data.grupo == 'MOVENERGY' ? data.id_programa_nomcar : data.id_programa }}
          td.is-size-7(:rowspan="getRowSpan(data, index)" v-show="getShowForRowSpan(data, index)" style="vertical-align : middle;text-align:center;")
            .columns.is-vcentered
              .column
                a.button.is-rounded.is-small(:class="data.pesoEntrada > 0 ? 'is-success' : 'is-warning'" @click="changePesoEntrada(data)")
                  | {{ data.pesoEntrada > 0 ? data.pesoEntrada : '-' }}
          td.is-size-7(:rowspan="getRowSpan(data, index)" v-show="getShowForRowSpan(data, index)" style="vertical-align : middle;text-align:center;")
            .columns.is-vcentered
              .column
                a.button.is-rounded.is-small(:class="data.pesoSalida > 0 ? 'is-success' : 'is-warning'" @click="changePesoSalida(data)")
                  | {{ data.pesoSalida > 0 ? data.pesoSalida : '-' }}
          td.is-size-7(:rowspan="getRowSpan(data, index)" v-show="getShowForRowSpan(data, index)" style="vertical-align : middle;text-align:center;" v-html="getPesoNeto(data, index)")
          td.is-size-7(v-show="verDataBascula")
            .columns.is-vcentered
              .column
                a.button.is-rounded.is-small(:class="data.magnatel > 0 ? 'is-success' : 'is-warning'" @click="changeMagnatel(data)")
                  | {{ data.magnatel > 0 ? data.magnatel : '-' }}
          td.is-size-7(v-show="verDataBascula")
            .columns.is-vcentered
              .column
                a.button.is-rounded.is-small(:class="data.presion > 0 ? 'is-success' : 'is-warning'" @click="changePresion(data)")
                  | {{ data.presion > 0 ? data.presion : '-' }}
          td.is-size-7(v-show="verCartasPorte")
            .columns.is-vcentered
              .column
                a.button.is-rounded.is-small(:class="data.embarque > 0 ? 'is-success' : 'is-warning'" @click="openCartaPorte(data)" v-if="verCartasPorte")
                  span.icon(v-show="data.embarque > 0 ")
                    i.fas.fa-print
                    | &nbsp&nbsp
                  | {{ data.embarque > 0 ? data.embarque : '-'}}
                span.tag(v-else :class="data.embarque > 0 ? 'is-black' : ''")
                  | {{ data.embarque > 0 ? data.embarque : '-'}}
          td.is-size-7
            .columns
              .column(:class="verDataBascula ? 'is-11': 'is-12'")
                div.field.is-grouped.is-grouped-multiline
                  div.control(v-for="sello in data.sellos" :key="sello.id")
                    div.tags.has-addons
                      span.tag(:class="sello.tipo === '1' ? 'is-dark' : 'is-light'")
                        | {{ sello.sello }}
                        button.delete(@click="borrarSello(sello)")
              .column.is-1(v-show="verDataBascula")
                a.button.is-info.is-rounded.is-small(@click="agregarSello(data)")
                  span.icon
                    i.fas.fa-plus
</template>

<script>
  import vueCustomScrollbar from 'vue-custom-scrollbar'
  import { mapState } from 'vuex'

  export default {
    name: 'TbLlegandoPesoNeto',
    components: { vueCustomScrollbar },
    props: {
      autotanques: {
        type: Array,
        default: () => []
      },
      nominaciones: {
        type: Array,
        default: () => []
      },
    },
    data() {
      return {
        settings: {
          maxScrollbarLength: 500
        },
        verCartasPorte: false,
        verDataBascula: false,
        verPrograma: false
      }
    },
    methods: {
      changePrograma (prog) {
        if (this.permisos.sca_irge == 5) {
          this.$emit('cambiarPrograma', prog)
        }
      },

      changePesoEntrada(data) {
        if (this.permisos.sca_irge == 6) {
          this.$emit('cambiarPesoEntrada', data)
        }
      },

      changePesoSalida(data) {
        if (this.permisos.sca_irge == 6) {
          this.$emit('cambiarPesoSalida', data)
        }
      },

      changeMagnatel(data) {
        if (this.permisos.sca_irge == 6) {
          this.$emit('cambiarMagnatel', data)
        }
      },

      changePresion(data) {
        if (this.permisos.sca_irge == 6) {
          this.$emit('cambiarPresion', data)
        }
      },

      changeGrupo(data) {
        if (this.permisos.sca_irge == 5) {
          this.$emit('cambiarGrupo', data)
        }
      },

      agregarSello(data) {
        if (this.permisos.sca_irge == 6) {
          this.$emit('agregarSello', data)
        }
      },

      borrarSello (data) {
        if (this.permisos.sca_irge == 6) {
          this.$emit('borrarSello', data)
        }
      },

      getRowSpan (acceso, index) {
        const nextIndex = index + 1
        if (nextIndex >= this.autotanques.length) {
          return 1
        }
        if (acceso.claveAcceso === this.autotanques[nextIndex].claveAcceso) {
          return 2
        } else {
          return 1
        }
      },

      getShowForRowSpan (acceso, index) {
        const prevIndex = index - 1
        if (index <= 0) {
          return true
        }
        if (acceso.claveAcceso === this.autotanques[prevIndex].claveAcceso) {
          return false
        } else {
          return true
        }
      },

      openCartaPorte (emb) {
        var currentUrl = window.location.hostname
        if (currentUrl === '10.122.40.189') {
          this.link = `http://${currentUrl}/servidores/reportes/cartaPorte_Irge.php?emb=${emb.embarque}&n=${emb.embarque}`
        }
        else {
          this.link = `https://${currentUrl}/servidores/reportes/cartaPorte_Irge.php?emb=${emb.embarque}&n=${emb.embarque}`
        }
        window.open(this.link, '_blank')
      },

      getbgColor (acc) {
        const nom = this.nominaciones.find( nom => nom.unidadNeg === acc.subgrupo)
        if (!nom) {
          return {
            'color': 'black',
            'backgroundColor': 'white'
          }
        }
        return {
          'color': nom.textColor,
          'backgroundColor': nom.color
        }
      },

      getPesoNeto(data, index) {
        const nextIndex = index + 1
        let pesoLlenadera = 0
        let pesoEntrada = data.pesoEntrada
        let pesoSalida = data.pesoSalida
        var pesoNeto = pesoSalida - pesoEntrada
        let diff = 0
        let numeroNormal = 0
        let html = ''

        if (nextIndex >= this.autotanques.length) {
          pesoLlenadera = data.masaLlenadera
          diff =  Math.abs(pesoLlenadera - pesoNeto)
          numeroNormal = diff < 200 && diff > -200
          const tagAlert = numeroNormal  ? 'is-dark' : 'is-danger'
          //console.log('diff : ' + diff)
          //console.log('numeroNormal : ' + numeroNormal)
          //console.log('pesoLlenadera: ' + pesoLlenadera)
          //console.log('pesoNeto: ' + pesoNeto)
          if (pesoNeto > 0) {
            if (pesoLlenadera > 0) {
              //console.log('pesoLlenadera: ' + pesoLlenadera)
              //console.log('pesoNeto: ' + pesoNeto)
              html = `<div class="tags has-addons">
                <span class="tag is-light">Dif: </span>
                <span class="tag ${tagAlert}">${diff}</span>
              </div>
              <div class="tags has-addons">
                <span class="tag is-light">Neto: </span>
                <span class="tag is-success">${pesoNeto}</span>
              </div>
              <div class="tags has-addons">
                <span class="tag is-light">Desp.: </span>
                <span class="tag is-black">${pesoLlenadera}</span>
              </div>
              `
              //console.log(html)
              return html
            } else {
              html = `<div class="tags has-addons">
                <span class="tag is-light">Neto: </span>
                <span class="tag is-success">${pesoNeto}</span>
              </div>`
              //console.log(html)
              return html
            }
          } else {
            return ''
          }
        }
        if (data.claveAcceso === this.autotanques[nextIndex].claveAcceso) {
          //console.log('data.masaLlenadera: ' + data.masaLlenadera)
          //console.log(this.autotanques[nextIndex].masaLlenadera)
          const masa1 = data.masaLlenadera
          const masa2 = this.autotanques[nextIndex].masaLlenadera
          pesoLlenadera = masa1 + masa2
          diff = Math.abs(pesoLlenadera - pesoNeto)
          numeroNormal = diff < 200 && diff > -200
          const tagAlert = numeroNormal  ? 'is-dark' : 'is-danger'
          //console.log('diff : ' + diff)
          //console.log('numeroNormal : ' + numeroNormal)
          //console.log('pesoLlenadera: ' + pesoLlenadera)
          //console.log('pesoNeto: ' + pesoNeto)
          if (pesoNeto > 0) {
            if (pesoLlenadera > 0) {
              //console.log('pesoLlenadera: ' + pesoLlenadera)
              //console.log('pesoNeto: ' + pesoNeto)
              html = `<div class="tags has-addons">
                <span class="tag is-light">Dif: </span>
                <span class="tag ${tagAlert}">${diff}</span>
              </div>
              <div class="tags has-addons">
                <span class="tag is-light">Neto: </span>
                <span class="tag is-success">${pesoNeto}</span>
              </div>
              <div class="tags has-addons">
                <span class="tag is-light">Desp.: </span>
                <span class="tag is-black">${pesoLlenadera}</span>
              </div>
              `
              //console.log(html)
              return html
            } else {
              html = `<div class="tags has-addons">
                <span class="tag is-light">Neto: </span>
                <span class="tag is-success">${pesoNeto}</span>
              </div>`
              //console.log(html)
              return html
            }
          } else {
            return ''
          }
        } else {
          //console.log('data.masaLlenadera: ' + data.masaLlenadera)
          pesoLlenadera = data.masaLlenadera
          diff = Math.abs(pesoLlenadera - pesoNeto)
          numeroNormal = diff < 200 && diff > -200
          const tagAlert = numeroNormal  ? 'is-dark' : 'is-danger'
          //console.log('diff : ' + diff)
          //console.log('numeroNormal : ' + numeroNormal)
          //console.log('pesoLlenadera: ' + pesoLlenadera)
          //console.log('pesoNeto: ' + pesoNeto)
          if (pesoNeto > 0) {
            if (pesoLlenadera > 0) {
              //console.log('pesoLlenadera: ' + pesoLlenadera)
              //console.log('pesoNeto: ' + pesoNeto)
              html = `<div class="tags has-addons">
                <span class="tag is-light">Dif: </span>
                <span class="tag ${tagAlert}">${diff}</span>
              </div>
              <div class="tags has-addons">
                <span class="tag is-light">Neto: </span>
                <span class="tag is-success">${pesoNeto}</span>
              </div>
              <div class="tags has-addons">
                <span class="tag is-light">Desp.: </span>
                <span class="tag is-black">${pesoLlenadera}</span>
              </div>
              `
              //console.log(html)
              return html
            } else {
              html = `<div class="tags has-addons">
                <span class="tag is-light">Neto: </span>
                <span class="tag is-success">${pesoNeto}</span>
              </div>`
              //console.log(html)
              return html
            }
          } else {
            return ''
          }
        }
      },
    },
    created () {
      switch (this.permisos.sca_irge) {
        case 1:
          this.verCartasPorte = true
          this.verDataBascula = false
          this.verPrograma = false
          break
        case 2:
          this.verCartasPorte = false
          this.verDataBascula = false
          this.verPrograma = false
          break
        case 3:
          this.verCartasPorte = false
          this.verDataBascula = false
          this.verPrograma = false
          break
        case 4:
          this.verCartasPorte = false
          this.verDataBascula = false
          this.verPrograma = false
          break
        case 5:
          this.verCartasPorte = false
          this.verDataBascula = false
          this.verPrograma = true
          break
        case 6:
          this.verCartasPorte = false
          this.verDataBascula = true
          this.verPrograma = false
          break
        case 7:
          this.verCartasPorte = true
          this.verDataBascula = false
          this.verPrograma = false
          break
        case 8:
          this.verCartasPorte = true
          this.verDataBascula = false
          this.verPrograma = false
          break
        default:
          this.verCartasPorte = false
          this.verDataBascula = false
          this.verPrograma = false
          break
      }
    },
    computed: {
      ...mapState(['logueado', 'userLogin', 'permisos']),
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/sca_Componentes/irge/cuartocontrol/componentes/TbLlegandoPesoNeto.vue